import React from 'react';
import './checkBoxStyles.scss';

const Checkbox = ({ label, checked, onChange, disabled, required }) => {
	const handleCheckboxChange = (event) => {
		if (disabled) return;
		onChange(event.target.checked);
	};

	return (
		<div className="form-check">
			<input
				checked={checked}
				onChange={handleCheckboxChange}
				disabled={disabled}
				className="form-check-input custumCheckBox"
				type="checkbox"
				id="flexCheckDefault"
			/>
			<label
				className="form-check-label"
				htmlFor="flexCheckDefault"
			>
				{label}
				{required && <span style={{ color: 'red', marginLeft: '.2rem' }}>*</span>}
			</label>
		</div>
	);
};
export default Checkbox;
